import { render } from "./ForgotPassword.vue?vue&type=template&id=c82e5428&scoped=true"
import script from "./ForgotPassword.js?vue&type=script&lang=js"
export * from "./ForgotPassword.js?vue&type=script&lang=js"

import "../login/Login.scss?vue&type=style&index=0&id=c82e5428&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c82e5428"]])

export default __exports__